import React from 'react';
import { TToggleButtonProps } from "types/Components/Common/Inputs/ToggleButton"

const ToggleButton = ({
    value = false,
    name = "toggle-button",
    defaultValue,
    disabled,
    onChange,
    id
}: TToggleButtonProps) => {
    return (
            <label id={`${id}`} htmlFor = {name} className="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer">
                <input data-testid="inputs-togglebutton-input-1" 
                type="checkbox" 
                checked={value} 
                disabled = {disabled}
                name={name} 
                id={name} 
                onChange={onChange}
                className={`tw-sr-only tw-peer/toggle-button-checkbox`}/>
                <div className={`tw-border-edge-strong tw-border tw-w-11 tw-h-6 tw-bg-edge-strong peer-focus/toggle-button-checkbox:tw-outline-none 
                    tw-rounded-full tw-transition-all tw-duration-300 after:tw-duration-300
                    peer-disabled/toggle-button-checkbox:tw-bg-ink-disabled
                    peer-disabled/toggle-button-checkbox:tw-border-ink-disabled
                    peer-checked/toggle-button-checkbox:after:tw-translate-x-full peer-checked/toggle-button-checkbox:after:tw-border-surface 
                    peer-checked/toggle-button-checkbox:after:tw-bg-surface 
                    after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-left-[2px] after:tw-shadow-ds-sm
                    after:tw-border-surface after:tw-bg-surface after:tw-border after:tw-rounded-full after:tw-h-5 after:tw-w-5 
                    after:tw-transition-all peer-checked/toggle-button-checkbox:tw-border-tone-success-bold peer-checked/toggle-button-checkbox:tw-bg-tone-success-bold`}></div>
            </label>
    )
}

export default ToggleButton